export default "__VITE_ASSET__BeI$78_$__"